.input-group{width:100%}
/*# sourceMappingURL=analytics-table-search-header.component-WRPQBTPX.css.map */
